export default "__VITE_ASSET__CRLKFqsc__"